@if (employeeTasks$ | async; as employeeTasks) {
    <div class="h-100">
        <app-table class="employee-assigned-tasks-table" [loadingTable]="taskAssigningIndicator.assigning">
            <ng-container header>
                <th class="flex-3" appTitleProvider>
                    <span>{{ 'TASK' | translate }}</span>
                </th>
                @if (rosterPresent) {
                    <th class="flex-2" appTitleProvider>
                        <span>{{ 'ROSTER_NAME' | translate }}</span>
                    </th>
                }
                <th class="flex-2" appTitleProvider>
                    <span>{{ 'TIME' | translate }}</span>
                </th>
                <th class="flex-1" appTitleProvider>
                    <span>{{ 'DURATION' | translate }}</span>
                </th>
                <th class="flex-2 justify-content-center" appTitleProvider>
                    <span>{{ 'ACTIVE' | translate }}</span>
                </th>
                <th class="flex-1 justify-content-center" appTitleProvider>
                    <span>{{ 'ACTIONS' | translate }}</span>
                </th>
                @if (taskAddressPresent | async) {
                    <th class="flex-1"></th>
                }
                <th class="icon-drag-column"></th>
            </ng-container>
            <ng-container body>
                <div
                    cdkDropList
                    cdkDropListSortingDisabled
                    [cdkDropListData]="employeeTasks"
                    (cdkDropListDropped)="drop($event)"
                    (cdkDropListEntered)="entered($event)"
                >
                    @for (task of employeeTasks; track task.taskId) {
                        @if (task.editing === false) {
                            <tr
                                cdkDrag
                                [cdkDragData]="task"
                                [cdkDragDisabled]="disableDrag || task.fixedToEmployee || !isEmployeeActive || task.isShiftSplitTask"
                                (cdkDragStarted)="started($event)"
                                (cdkDragReleased)="released()"
                                [ngClass]="{'shift-split': task.isShiftSplitTask }"
                                class="py-0"
                            >
                                <td class="flex-3" appTitleProvider>
                                    <span>{{ task.serviceName }}</span>
                                </td>
                                @if (rosterPresent) {
                                    <td class="flex-2" appTitleProvider>
                                        <span>{{ task.rosterDepartmentName }}</span>
                                    </td>
                                }
                                <td class="flex-2" appTitleProvider>
                                    <span> {{ task | fromto }}</span>
                                </td>
                                <td class="flex-1" appTitleProvider>
                                    <span>{{ task.duration }} min</span>
                                </td>
                                <td class="flex-2 justify-content-center">
                                    <span [ngClass]="{'icon-checkmark': task.isActive,
                                                    'icon-close-blue': !task.isActive}">
                                    </span>
                                </td>
                                <td class="flex-1 justify-content-center my-auto">
                                    <app-tooltip
                                        title="{{'EDIT_TASK' | translate}}"
                                        [compact]="true"
                                        (click)="editTask(task, $event)"
                                    >
                                        <ng-container icon>
                                            <span
                                                class="vismaicon vismaicon-sm vismaicon-edit"
                                            ></span>
                                        </ng-container>
                                    </app-tooltip>
                                </td>
                                @if (taskAddressPresent | async) {
                                    <td class="flex-1 justify-content-end my-auto">
                                        @if (task.feasibilityInfo) {
                                            <app-feasibility-info
                                                [feasibilityInfo]="task.feasibilityInfo"
                                            ></app-feasibility-info>
                                        }
                                        @if (task.streetAddressNameNumberAndLetter) {
                                            <app-tooltip
                                                class="vismaicon-edit"
                                                appCustomPopover
                                                placement="left"
                                                [popoverType]="task.addressIsValid ? 'default' : 'error'"
                                                [popoverText]="task.addressIsValid ? task.streetAddressNameNumberAndLetter : 'FEASIBILITY_ADDRESS_NOT_FOUND_ERROR'"
                                                [adaptPlacement]="true"
                                                (keydown)="openAdminTaskAddressModal(task)"
                                                (click)="openAdminTaskAddressModal(task)"
                                            >
                                                <ng-container icon>
                                                    <span [ngClass]="{'icon-location-blue': task.addressIsValid,
                                                      'icon-location-red': !task.addressIsValid }"></span>
                                                </ng-container>
                                            </app-tooltip>
                                        }
                                    </td>
                                }
                                <td class="icon-drag-column my-auto">
                                    @if (!disableDrag && !task.fixedToEmployee && isEmployeeActive && !task.isShiftSplitTask) {
                                        <app-tooltip
                                            title="{{ 'DRAG_TASK' | translate}}"
                                        >
                                            <ng-container icon>
                                                <span class="vismaicon icon-draggable-indicator"></span>
                                            </ng-container>
                                        </app-tooltip>
                                    }
                                </td>
                            </tr>
                        }
                        @if (task.editing) {
                            <app-employee-assigned-task-edit [employeeTask]="task"
                                                             [taskAddressPresent]="taskAddressPresent | async"
                                                             (updateProblemInstanceEmitter)="updateProblemInstance($event)"
                                                             (disableDraggingEmitter)="disableDrag = $event"
                            ></app-employee-assigned-task-edit>
                        }
                    }
                </div>
            </ng-container>
        </app-table>
    </div>
}
